import MuiButtonGroup, { type ButtonGroupProps } from "@mui/material/ButtonGroup";

export type { ButtonGroupProps };

export function ButtonGroup({ variant = "contained", ...props }: ButtonGroupProps) {
  return <MuiButtonGroup variant={variant} {...props} />;
}
